<div
    class="image-container overflow-hidden"
    *ngIf="(currentLeadCaptureScreen !== LEAD_CAPTURE_SCREEN.SUCCESS) && (isLoggedIn$ | async) && navigator.onLine"
>
    <div class="webcam-container position-relative w-100 h-100">
        <!-- Error shown when user camera is not accessible -->
        <div class="error-modal bg-light position-absolute start-50 translate-middle p-4 rounded-3" *ngIf="errorCamera">
            <div>
                <div>
                    <img
                        src="/img/icons/exclamation-message.svg"
                        alt="error triangle exclamation"
                        class="mb-2 me-3 error-icon"
                    />
                    <span class="fs-1">Access Denied</span>
                </div>
                <p>
                    Enable camera permissions from your browser settings to proceed.
                </p>
                <button
                    class="btn btn-transparent text-primary w-100 mt-3"
                    (click)="handleCloseScreen()"
                >
                    Dismiss
                </button>
            </div>
        </div>


        <!-- Capture state screen - WEBCAM -->
        <div class="position-relative w-100 h-100" *ngIf="currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.CAPTURE">
            <video
                class="w-100 h-100"
                #videoElement
                autoplay
                playsinline
            ></video>
            <div
                class="position-absolute top-0 start-0 h-100 w-100 capture-frame-outside"
            ></div>
            <div
                class="position-absolute capture-frame-square start-50 translate-middle"
            >
                <div class="border border-2 border-light w-100 h-100"></div>
                <p class="mt-3 mb-0 text-center text-light">
                    Position your card inside the frame
                </p>
            </div>
        </div>

        <!-- This will be shown when the user clicks on the capture button. It will trigger the animation -->
        <div
            *ngIf="currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.PARSING"
        >
            <img
                [src]="tempCaptureImage"
                class="image-capture-flash"
                alt="result capture img"
            />
        </div>
        <audio #imageCaptureAudio src="/audio/camera-capture.mp3"></audio>
    </div>

    <!-- Capture state screen - Camera Navigation and control -->
    <div
        class="w-100 d-flex justify-content-around align-items-center image-stream-button-panel position-fixed start-0 bottom-0"
        [ngClass]="{
            '': currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.CAPTURE,
            'd-none': currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.PARSING,
        }"
    >
        <div>
            <label for="file-upload">
                <img
                    src="/img/icons/folder-image.svg"
                    alt="Upload"
                    class="upload-icon"
                />
            </label>
            <input id="file-upload" type="file" accept="image/*" (change)="handleUploadImageFromStorage($event)" hidden />
        </div>

        <button
            class="bg-light rounded-circle border-0 capture-button"
            [disabled]="loadingCamera"
            (click)="captureImage()"
        ></button>

        <button
            class="btn btn-transparent border-0 text-light p-0"
            [ngClass]="{
                'opacity-0': isiOS,
            }"
            [disabled]="loadingCamera && isiOS"
            (click)="handleFlashToggle()"
        >
            <img
                [src]="flashLight ? '/img/icons/flash-enable.svg' : '/img/icons/flash-disable.svg'"
                alt="Upload"
                class="flash-icon"
            />
        </button>
    </div>
    <canvas #canvas class="d-none"></canvas>
</div>

<!-- Enable/Disable - Add contact screen -->
<div *ngIf="currentLeadCaptureScreen === LEAD_CAPTURE_SCREEN.SUCCESS">
    <app-image-capture-create-lead
        [capturedImage]="capturedImage"
        (closeScreen)="closeLeadListScreen()"
    ></app-image-capture-create-lead>
</div>


<!-- SHOW LOGGED OUT STATE ERROR -->
<div class="image-capture-logged-out" *ngIf="!(isLoggedIn$ | async) || !navigator.onLine">
    <div class="d-flex justify-content-center align-items-center flex-column w-100 h-100">
        <p class="text-grey fs-2 mb-0 fw-500">
            {{ navigator.onLine ? 'Unable to launch camera' : 'You\'re currently offline' }}
        </p>
        <p *ngIf="!(isLoggedIn$ | async) && navigator.onLine" class="text-grey">
            Try logging in
        </p>
        <p class="text-grey" *ngIf="!navigator.onLine">
            Connect to internet to launch camera
        </p>
    </div>
    
    <!-- Add bottom navigation menu bar -->
    <app-bottom-nav>
    </app-bottom-nav>
</div>